import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Паровоз ТЭ 2596';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Типа 1-5-0 серии ТЭ №2596</p>
                    <p>Построен в 1943 году в Германии</p>
                    <p>Колея - 1435 мм</p>
                    <p>Расчетный вес паровоза с тендером 135т</p>
                    <p>Нагрузка на ось - 15,4т</p>
                    <p>Конструктивная скорость - 80 км/ч</p>
                    <p>Предельное рабочее давление пара в котле - 16кг/см2</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt022.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt023.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt024.jpg')} /></div>
            </div>
        </>
    );
}